import account from './account';
import profile from './profile';
import signals from './signals';
import alerts from './alerts';
import teasers from './teasers';

export default { ...teasers, ...alerts, ...signals, ...profile, ...account };
